window.tab=function(name){
  $(".list").hide().eq(name).show();
  $(".tab span").removeClass("current").eq(name).addClass("current")
};